import  React, {useEffect} from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "../../Svg/DeleteIcon";
import BellIcon from "../../Svg/BellIcon";
import { Icon, Pagination, Paper, TextField } from "@mui/material";
import { Box } from "@mui/system";
import "./NotifTable.css";
import axios from "axios";
// import DatePick from "../DatePick";
// import { DatePicker } from "@material-ui/pickers";

function createData(activity, sender, date, icon) {
  return { activity, sender, date, icon };
}

const rows = [
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
  createData(
    "You Recieved A Payment",
    "Richard Daniel",
    "7 March 2022",
    <DeleteIcon />
  ),
];



export default function NotifTable() {


  const [dum, setDum] = React.useState({})



useEffect(() => {
  axios.get("https://jsonplaceholder.typicode.com/todos").then((res, data) => {
    setDum(res)
  });
}, [])
console.log(dum);

  return (

    <Box className="TB" marginTop={"50px"}>
    <TableContainer component={Paper} sx={{ borderRadius: "12px" }}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table" className="TB">
        <TableHead>
          <TableRow sx={{ textAlign: "center", backgroundColor: "#00008B12" }}>
            <TableCell
              sx={{
                font: "Lato",
                Weight: "600, Semi Bold",
                size: "16px",
                fontWeight: "bold",
                color: "gray",
              }}
              align="center"
            >
              Activity
            </TableCell>
            <TableCell
              sx={{
                font: "Lato",
                Weight: "600, Semi Bold",
                size: "16px",
                fontWeight: "bold",
                color: "gray",
              }}
              align="center"
            >
               
              Sender
            </TableCell>
            <TableCell
              sx={{
                font: "Lato",
                Weight: "600, Semi Bold",
                size: "16px",
                fontWeight: "bold",
                color: "gray",
              }}
              align="center"
            >
              Date
            </TableCell>
            <TableCell
              sx={{
                font: "Lato",
                Weight: "600, Semi Bold",
                size: "16px",
                fontWeight: "bold",
                color: "gray",
              }}
              align="center"
            >
              Delete
            </TableCell>
          </TableRow>
          
          <TextField
            type={"search"}
            placeholder="Search"
            size="small"
            margin="dense"
            sx={{ left: "17%", width: "115%", padding: "10px" }}
            
          />
          
          {/* Date Picker Issue to Be Fixed */}
          {/* <DatePicker /> */}
           
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.activity}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "space-evenly",
                }}
              >
                <Icon>
                  <BellIcon />
                </Icon>
                {row.activity}
              </TableCell>
              <TableCell align="center">{row.sender}</TableCell>
              <TableCell align="center">{row.date}</TableCell>
              <TableCell align="center">{row.icon}</TableCell>
            </TableRow>
            
          ))}
        </TableBody>
      </Table>
      <Box textAlign="center">
        <Pagination
          sx={{ marginLeft: "400px", color: "#e57373", display: "flex" }}
          count={3}
          shape="rounded"
       
        />
      </Box>
    </TableContainer>
    </Box>
  );
}
